import { Address, ImageInfo } from "./common";

export class Signup {
  constructor() {
    this.address = new Address();
    this.imageInfo = new Array<ImageInfo>();
    this.isClient = true;
    this.addedBy = null
  }
  public companyName: string;
  public email: string;
  public password: string;
  public subdomain: string;
  public address: Address;
  public isClient: boolean;
  public phone: string;
  public imageInfo: Array<ImageInfo>;
  public addedBy:string
}
